declare global {
  interface Window {
    mixpanel: any;
    ga: any;
  }
}

export const mixpanel = {
  track: (eventName: string, properties: any): void => {
    if (typeof window.mixpanel !== 'undefined') {
      window.mixpanel.track(eventName, properties);
    }
  },
};

export const ga = {
  track: (
    category: string,
    action: string = '',
    label: string = '',
    value: string = '',
  ): void => {
    if (typeof window.ga !== 'undefined') {
      window.ga('send', 'event', category, action, label, value);
    }
  },
};
